import React, { forwardRef } from 'react'
import { withRouter } from 'react-router'

export function withRouterForwardRef(WrappedComponent) {
    const WithRouter = withRouter(({ forwardedRef, ...props }) => <WrappedComponent ref={forwardedRef} {...props} />)

    return forwardRef((props, ref) => <WithRouter {...props} forwardedRef={ref} />)
}
